import { createAction, props } from '@ngrx/store';

import { SortDirection } from 'Angular/types/sort-direction.type';

export const setFundChartSortDirection = createAction(
    '[Fund Chart] Set Sort Direction',
    props<{ sortDirection: SortDirection | '' }>()
);
